import { render, staticRenderFns } from "./dilog.vue?vue&type=template&id=c9cf0dc4&scoped=true&"
import script from "./dilog.vue?vue&type=script&lang=js&"
export * from "./dilog.vue?vue&type=script&lang=js&"
import style0 from "./dilog.vue?vue&type=style&index=0&id=c9cf0dc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cf0dc4",
  null
  
)

export default component.exports